import { createContext, useContext } from "react";

export const translations = {
    es: {
        nav: {
            brandSub: "Fabiana Padrón",
            links: [
                { label: "Fabiana", hash: "#fabiana", id: "nav-link-fabiana" },
                { label: "Qué es IUL", hash: "#iul", id: "nav-link-iul" },
                { label: "Credenciales", hash: "#credenciales", id: "nav-link-credenciales" },
                { label: "Testimonios", hash: "#testimonios", id: "nav-link-testimonios" },
                { label: "Preguntas", hash: "#preguntas", id: "nav-link-faq" },
            ],
            cta: "Agenda tu llamada",
        },
        hero: {
            eyebrow: "Seguro de Vida · Estrategia IUL",
            lines: [
                { text: "Tu legado", italic: false },
                { text: "empieza con una", italic: false },
                { text: "buena estrategia.", italic: true },
            ],
            introA: "Soy ",
            introName: "Fabiana Padrón",
            introB: ", agente de seguros de vida. Si ya conversamos por teléfono, aquí conocerás quién soy, cómo trabajo y qué puede hacer un IUL por tu familia.",
            primary: "Agenda tu llamada hoy",
            secondary: "Descubre qué es un IUL",
            trust: ["Atención en español", "Sin compromiso", "100% confidencial"],
            badgeTitle: "Agente de Seguros de Vida",
            badgeSub: "Estrategias de legado para familias hispanas",
            portraitAlt: "Fabiana Padrón, agente de seguros de vida de FP Legacy Insurance",
        },
        marquee: {
            items: ["FP Legacy Insurance", "Fabiana Padrón", "Vida Universal Indexada", "Protección · Estrategia · Legado"],
        },
        about: {
            eyebrow: "Conóceme",
            title: "Mucho gusto, soy Fabiana.",
            p1: "Llegaste hasta aquí porque ya conversamos por teléfono, y eso me alegra. Mi trabajo no es venderte una póliza: es entender a tu familia, tus metas y tus preocupaciones, y diseñar contigo una estrategia de protección que realmente te sirva.",
            p2a: "Me especializo en el ",
            p2Highlight: "Seguro de Vida Universal Indexado (IUL)",
            p2b: ", una herramienta que combina protección de por vida con crecimiento potencial de tu dinero. Te lo explico en palabras sencillas, sin letra pequeña ni presión.",
            p3: "Detrás de FP Legacy Insurance hay una convicción: las familias hispanas merecen asesoría financiera clara, honesta y en su idioma.",
            facts: ["Acompañamiento 1:1", "Todo en español", "Sin compromiso"],
        },
        iul: {
            eyebrow: "En palabras simples",
            title: "¿Qué es un IUL?",
            p1a: "Un ",
            p1Highlight: "Seguro de Vida Universal Indexado",
            p1b: " (IUL, por sus siglas en inglés) es un seguro de vida que hace dos cosas a la vez: protege a tu familia con un beneficio por fallecimiento y acumula un valor en efectivo que puede crecer con los años.",
            p2: "A diferencia de invertir directamente en la bolsa, tu dinero no está expuesto a las caídas del mercado: cuando el índice baja, tu valor no pierde por eso. Y cuando sube, participas de ese crecimiento hasta cierto límite.",
            pillars: [
                { title: "Protección de por vida", text: "Un beneficio que protege a tu familia pase lo que pase, y que puede crecer con el tiempo." },
                { title: "Crecimiento con piso", text: "Tu valor en efectivo puede crecer ligado a índices del mercado, con un piso que te protege cuando el mercado cae." },
                { title: "Flexibilidad real", text: "Tú decides con cuánto empezar, con opciones libres de impuestos para acceso a tu valor en efectivo." },
                { title: "Beneficios en vida por enfermedad", text: "Si enfrentas una enfermedad grave, crónica o terminal, puedes acceder a parte del beneficio de tu póliza mientras vives, para cubrir gastos médicos o lo que tu familia necesite." },
            ],
            fineprint: "El IUL es un seguro de vida, no una inversión ni un valor. Los límites de crecimiento, tasas de participación y cargos varían según la póliza y la aseguradora. En nuestra llamada revisamos si es adecuado para ti, con números claros.",
            badgeValue: "0%",
            badgeLabel: "Piso ante caídas del mercado",
            imageAlt: "Familia unida al atardecer, símbolo del legado que protege un IUL",
        },
        credentials: {
            eyebrow: "Confianza verificable",
            title: "Licencias y credenciales.",
            intro: "Tu tranquilidad empieza por saber con quién hablas. Mi ejercicio profesional está respaldado por licencias estatales y es verificable de forma pública.",
            items: [
                { title: "Acceso a las compañías de Seguro más grandes de USA", detail: "Americo · Mutual of Omaha · Fidelity & Guaranty · Transamerica · National Life Group · American Amicable" },
                { title: "Estados licenciados", detail: "California · Texas · Colorado · Illinois · Florida · Virginia · New Jersey · New York · West Virginia · North Carolina" },
                { title: "Verificación de licencia", detail: "Podrás verificar mi licencia en nipr.com y en el departamento de seguros de tu estado." },
            ],
            fineprint: "La información de licencia se actualiza periódicamente. Si deseas verificar mis credenciales antes de nuestra llamada, con gusto te comparto los datos completos.",
            carriersTitle: "Las compañías detrás de tu estrategia",
            carriersFine: "Las marcas mostradas pertenecen a sus respectivos propietarios.",
        },
        testimonials: {
            eyebrow: "Voces reales",
            title: "Lo que dicen quienes ya dieron el paso.",
            items: [
                { quote: "Fabiana me explicó todo con una paciencia que nunca había visto. Por primera vez entiendo exactamente qué estoy pagando y por qué.", name: "María G.", location: "Miami, FL" },
                { quote: "Pensé que un seguro de vida era solo un gasto. Después de nuestra llamada, lo veo como la base del legado de mis hijos.", name: "Carlos R.", location: "Houston, TX" },
                { quote: "Cero presión, todo claridad. Me envió los números por escrito y me dio tiempo de decidir con mi esposo. Así da gusto.", name: "Ana L.", location: "Orlando, FL" },
            ],
            fine: "* Testimonios de muestra. Las reseñas reales de clientes se publican con su autorización expresa.",
        },
        faq: {
            eyebrow: "Dudas comunes",
            title: "Preguntas frecuentes.",
            items: [
                { q: "¿Puedo perder dinero si el mercado cae?", a: "No directamente. Tu valor en efectivo tiene un piso (generalmente 0%): cuando el índice baja, tu valor no se reduce por esa caída. Solo se descuentan los cargos normales de la póliza." },
                { q: "¿Cuánto necesito para empezar?", a: "Hay opciones para distintos presupuestos. Tú decides con cuánto empezar, y en nuestra llamada diseñamos un plan que se ajuste a ti sin comprometer tus gastos." },
                { q: "¿Puedo usar mi dinero antes del retiro?", a: "Sí. Puedes acceder a tu valor en efectivo mediante préstamos o retiros de la póliza, con opciones libres de impuestos, sujeto a los términos de tu póliza." },
                { q: "¿Necesito un examen médico?", a: "Depende de tu edad, tu salud y el monto de cobertura. Muchos casos se aprueban sin examen médico. Lo revisamos juntos antes de aplicar." },
                { q: "¿Qué pasa si un mes no puedo pagar?", a: "El IUL es flexible: el valor que ya acumulaste puede mantener tu cobertura activa por un tiempo. Te explico exactamente cómo funciona antes de decidir." },
                { q: "¿En qué estados puedes atenderme?", a: "Estoy licenciada en California, Texas, Colorado, Illinois, Florida, Virginia, New Jersey, New York, West Virginia y North Carolina." },
            ],
        },
        contact: {
            eyebrow: "El siguiente paso",
            title: "Agenda tu llamada hoy.",
            intro: "Tu legado empieza con una buena estrategia. Elige la forma que te sea más cómoda y conversemos sin compromiso.",
            calendlyTitle: "Agenda en Calendly",
            calendlySub: "Elige la fecha y hora que prefieras",
            phoneSub: "Llámame directamente",
            whatsappSub: "Escríbeme ahora mismo",
            emailSub: "Escríbeme por correo",
            form: {
                title: "Prefiero que me contacten",
                sub: "Déjame tus datos y te llamo personalmente.",
                labelNombre: "Nombre completo",
                labelTelefono: "Teléfono",
                labelEmail: "Correo electrónico",
                labelMensaje: "Mensaje (opcional)",
                phNombre: "Tu nombre",
                phTelefono: "+1 (___) ___-____",
                phEmail: "tu@correo.com",
                phMensaje: "Cuéntame brevemente qué te gustaría lograr",
                submit: "Solicitar que me contacten",
                sending: "Enviando...",
                privacy: "Tus datos se usan solo para contactarte. Nunca se comparten con terceros.",
            },
            toastSuccess: "¡Gracias! Fabiana te contactará muy pronto.",
            toastError: "No pudimos enviar tu solicitud. Intenta por WhatsApp o teléfono.",
        },
        footer: {
            tagline: "Fabiana Padrón · Agente de Seguros de Vida",
            privacyTitle: "Aviso de Privacidad",
            privacyText: "La información que compartes a través de este sitio se utiliza únicamente para contactarte y preparar tu llamada. No vendemos, alquilamos ni compartimos tus datos personales con terceros. Puedes solicitar la eliminación de tu información en cualquier momento.",
            legalTitle: "Descargo Legal",
            legalText: "FP Legacy Insurance es una agencia independiente de seguros de vida. Los productos de seguro no son depósitos bancarios, no están asegurados por la FDIC ni por ninguna agencia gubernamental, y pueden perder valor. Un Seguro de Vida Universal Indexado (IUL) es un producto de seguro de vida, no una inversión ni un valor. El crecimiento del valor en efectivo está sujeto a límites, tasas de participación y cargos de la póliza. Las garantías dependen de la capacidad de pago de reclamaciones de la aseguradora emisora. La disponibilidad de productos varía por estado. Este sitio tiene fines informativos y no constituye asesoría fiscal, legal ni de inversión.",
            rights: "Todos los derechos reservados.",
            reviewLink: "Déjanos tu reseña",
        },
        mobileCta: { call: "Llamar", whatsapp: "WhatsApp", book: "Agendar" },
        review: {
            ctaEyebrow: "Tu opinión cuenta",
            ctaTitle: "¿Ya conversamos? Déjanos tu reseña",
            ctaSub: "Tu experiencia puede ayudar a otras familias a dar el paso con confianza.",
            title: "Comparte tu experiencia",
            sub: "Tu opinión ayuda a otras familias a dar el paso con confianza. Gracias por tomarte un minuto.",
            ratingLabel: "Tu calificación",
            nameLabel: "Tu nombre",
            namePh: "Ej. María G.",
            locationLabel: "Ciudad y estado (opcional)",
            locationPh: "Ej. Miami, FL",
            reviewLabel: "Tu reseña",
            reviewPh: "Cuéntanos cómo fue tu experiencia con Fabiana...",
            submit: "Enviar mi reseña",
            sending: "Enviando...",
            fine: "Tu reseña se publica únicamente con la aprobación de FP Legacy Insurance.",
            ratingError: "Por favor selecciona una calificación de estrellas.",
            submitError: "No pudimos enviar tu reseña. Intenta de nuevo.",
            successTitle: "¡Gracias por tu reseña!",
            successText: "Tu opinión significa mucho. Una vez revisada, podría aparecer en la página para inspirar a otras familias.",
            backHome: "Volver a la página",
        },
    },
    en: {
        nav: {
            brandSub: "Fabiana Padrón",
            links: [
                { label: "Fabiana", hash: "#fabiana", id: "nav-link-fabiana" },
                { label: "What is IUL", hash: "#iul", id: "nav-link-iul" },
                { label: "Credentials", hash: "#credenciales", id: "nav-link-credenciales" },
                { label: "Testimonials", hash: "#testimonios", id: "nav-link-testimonios" },
                { label: "FAQ", hash: "#preguntas", id: "nav-link-faq" },
            ],
            cta: "Book your call",
        },
        hero: {
            eyebrow: "Life Insurance · IUL Strategy",
            lines: [
                { text: "Your legacy", italic: false },
                { text: "starts with a", italic: false },
                { text: "solid strategy.", italic: true },
            ],
            introA: "I'm ",
            introName: "Fabiana Padrón",
            introB: ", a life insurance agent. If we've already spoken by phone, here you'll learn who I am, how I work, and what an IUL can do for your family.",
            primary: "Book your call today",
            secondary: "Discover what an IUL is",
            trust: ["Service in English & Spanish", "No obligation", "100% confidential"],
            badgeTitle: "Life Insurance Agent",
            badgeSub: "Legacy strategies for Hispanic families",
            portraitAlt: "Fabiana Padrón, life insurance agent at FP Legacy Insurance",
        },
        marquee: {
            items: ["FP Legacy Insurance", "Fabiana Padrón", "Indexed Universal Life", "Protection · Strategy · Legacy"],
        },
        about: {
            eyebrow: "Get to know me",
            title: "Nice to meet you, I'm Fabiana.",
            p1: "You landed here because we already spoke by phone — and that makes me glad. My job isn't to sell you a policy: it's to understand your family, your goals and your concerns, and to design with you a protection strategy that truly serves you.",
            p2a: "I specialize in ",
            p2Highlight: "Indexed Universal Life insurance (IUL)",
            p2b: ", a tool that combines lifelong protection with potential growth of your money. I explain it in plain words, with no fine print and no pressure.",
            p3: "Behind FP Legacy Insurance there is a conviction: Hispanic families deserve clear, honest financial guidance in their own language.",
            facts: ["1:1 guidance", "English & Spanish", "No obligation"],
        },
        iul: {
            eyebrow: "In plain words",
            title: "What is an IUL?",
            p1a: "An ",
            p1Highlight: "Indexed Universal Life insurance",
            p1b: " (IUL) is a life insurance policy that does two things at once: it protects your family with a death benefit and builds cash value that can grow over the years.",
            p2: "Unlike investing directly in the stock market, your money is not exposed to market drops: when the index falls, your value doesn't lose because of it. And when it rises, you share in that growth up to a certain cap.",
            pillars: [
                { title: "Lifelong protection", text: "A benefit that protects your family no matter what, and that can grow over time." },
                { title: "Growth with a floor", text: "Your cash value can grow linked to market indexes, with a floor that protects you when the market falls." },
                { title: "Real flexibility", text: "You decide how much to start with, with tax-free options to access your cash value." },
                { title: "Living benefits for illness", text: "If you face a serious, chronic or terminal illness, you can access part of your policy's benefit while you're alive, to cover medical expenses or whatever your family needs." },
            ],
            fineprint: "An IUL is life insurance, not an investment or a security. Growth caps, participation rates and charges vary by policy and insurer. On our call we'll review whether it's right for you, with clear numbers.",
            badgeValue: "0%",
            badgeLabel: "Floor against market drops",
            imageAlt: "Family together at sunset, symbol of the legacy an IUL protects",
        },
        credentials: {
            eyebrow: "Verifiable trust",
            title: "Licenses & credentials.",
            intro: "Your peace of mind starts with knowing who you're talking to. My professional practice is backed by state licenses and is publicly verifiable.",
            items: [
                { title: "Access to the largest insurance companies in the USA", detail: "Americo · Mutual of Omaha · Fidelity & Guaranty · Transamerica · National Life Group · American Amicable" },
                { title: "Licensed states", detail: "California · Texas · Colorado · Illinois · Florida · Virginia · New Jersey · New York · West Virginia · North Carolina" },
                { title: "License verification", detail: "You can verify my license at nipr.com and at your state's department of insurance." },
            ],
            fineprint: "License information is updated periodically. If you'd like to verify my credentials before our call, I'll gladly share the full details.",
            carriersTitle: "The companies behind your strategy",
            carriersFine: "Trademarks shown belong to their respective owners.",
        },
        testimonials: {
            eyebrow: "Real voices",
            title: "What those who already took the step say.",
            items: [
                { quote: "Fabiana explained everything with a patience I had never seen. For the first time I understand exactly what I'm paying for and why.", name: "María G.", location: "Miami, FL" },
                { quote: "I thought life insurance was just an expense. After our call, I see it as the foundation of my children's legacy.", name: "Carlos R.", location: "Houston, TX" },
                { quote: "Zero pressure, all clarity. She sent me the numbers in writing and gave me time to decide with my husband. That's how it should be.", name: "Ana L.", location: "Orlando, FL" },
            ],
            fine: "* Sample testimonials. Real client reviews are published with their express authorization.",
        },
        faq: {
            eyebrow: "Common questions",
            title: "Frequently asked questions.",
            items: [
                { q: "Can I lose money if the market drops?", a: "Not directly. Your cash value has a floor (typically 0%): when the index falls, your value doesn't decrease because of that drop. Only the policy's normal charges are deducted." },
                { q: "How much do I need to start?", a: "There are options for different budgets. You decide how much to start with, and on our call we design a plan that fits you without straining your expenses." },
                { q: "Can I use my money before retirement?", a: "Yes. You can access your cash value through policy loans or withdrawals, with tax-free options, subject to your policy's terms." },
                { q: "Do I need a medical exam?", a: "It depends on your age, your health and the coverage amount. Many cases are approved without a medical exam. We review this together before applying." },
                { q: "What happens if I can't pay one month?", a: "IUL is flexible: the value you've already built can keep your coverage active for a while. I'll explain exactly how it works before you decide." },
                { q: "Which states can you serve?", a: "I'm licensed in California, Texas, Colorado, Illinois, Florida, Virginia, New Jersey, New York, West Virginia and North Carolina." },
            ],
        },
        contact: {
            eyebrow: "The next step",
            title: "Book your call today.",
            intro: "Your legacy starts with a solid strategy. Choose whichever way is most comfortable for you and let's talk — no obligation.",
            calendlyTitle: "Book on Calendly",
            calendlySub: "Pick the date and time you prefer",
            phoneSub: "Call me directly",
            whatsappSub: "Message me right now",
            emailSub: "Write me an email",
            form: {
                title: "I'd rather be contacted",
                sub: "Leave your details and I'll call you personally.",
                labelNombre: "Full name",
                labelTelefono: "Phone",
                labelEmail: "Email",
                labelMensaje: "Message (optional)",
                phNombre: "Your name",
                phTelefono: "+1 (___) ___-____",
                phEmail: "you@email.com",
                phMensaje: "Briefly tell me what you'd like to achieve",
                submit: "Request to be contacted",
                sending: "Sending...",
                privacy: "Your information is only used to contact you. It's never shared with third parties.",
            },
            toastSuccess: "Thank you! Fabiana will contact you very soon.",
            toastError: "We couldn't send your request. Please try WhatsApp or phone.",
        },
        footer: {
            tagline: "Fabiana Padrón · Life Insurance Agent",
            privacyTitle: "Privacy Notice",
            privacyText: "The information you share through this site is used solely to contact you and prepare your call. We do not sell, rent or share your personal data with third parties. You may request the deletion of your information at any time.",
            legalTitle: "Legal Disclaimer",
            legalText: "FP Legacy Insurance is an independent life insurance agency. Insurance products are not bank deposits, are not insured by the FDIC or any government agency, and may lose value. An Indexed Universal Life (IUL) policy is a life insurance product, not an investment or a security. Cash value growth is subject to caps, participation rates and policy charges. Guarantees depend on the claims-paying ability of the issuing insurer. Product availability varies by state. This site is for informational purposes only and does not constitute tax, legal or investment advice.",
            rights: "All rights reserved.",
            reviewLink: "Leave us a review",
        },
        mobileCta: { call: "Call", whatsapp: "WhatsApp", book: "Book" },
        review: {
            ctaEyebrow: "Your voice matters",
            ctaTitle: "Have we talked? Leave your review",
            ctaSub: "Your experience can help other families take the step with confidence.",
            title: "Share your experience",
            sub: "Your feedback helps other families take the step with confidence. Thank you for taking a minute.",
            ratingLabel: "Your rating",
            nameLabel: "Your name",
            namePh: "E.g. Maria G.",
            locationLabel: "City and state (optional)",
            locationPh: "E.g. Miami, FL",
            reviewLabel: "Your review",
            reviewPh: "Tell us how your experience with Fabiana was...",
            submit: "Send my review",
            sending: "Sending...",
            fine: "Your review is published only with FP Legacy Insurance's approval.",
            ratingError: "Please select a star rating.",
            submitError: "We couldn't send your review. Please try again.",
            successTitle: "Thank you for your review!",
            successText: "Your feedback means a lot. Once reviewed, it may appear on the page to inspire other families.",
            backHome: "Back to the page",
        },
    },
};

export const LanguageContext = createContext({
    lang: "es",
    setLang: () => {},
    t: translations.es,
});

export const useLang = () => useContext(LanguageContext);
